import React, { useEffect } from 'react';
import CouponList from './Components/Coupons/CouponList';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCoupons, setModal } from '../../Features/couponsSlice';
import { CouponContextProvider } from '../../Context/Coupons/CouponContext';
import Modal from './Components/Modals/Modal';
import Loading from '../../Components/Loading/Loading';
import Error from '../../Components/Error/Error';

function CouponManagement() {
    const dispatch = useDispatch();

    const { coupons, loading } = useSelector((state) => state.coupons.coupons);

    const handleCreateCoupon = () => {
        dispatch(setModal('select-coupon-type'));
    }

    useEffect(() => {
        dispatch(fetchCoupons());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if(loading === 'loading') {
        return <Loading />
    }

    if(loading === 'failed') {
        return <Error />
    }

    return (
        <div className="size-full overflow-y-scroll pb-16 outline-none">
            <div className="flex items-center justify-between gap-6 m-[20px_19px_24px_20px]">
                <h1 className="text-[#121212] font-bold text-2xl select-none">Coupon Management</h1>

                {
                    coupons.length !== 0 && 
                    <button onClick={handleCreateCoupon} className='outline-none flex items-center gap-[2px] px-4 py-2 bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>Create Coupon</button>
                }
            </div>

            <CouponContextProvider>
                <CouponList />
            </CouponContextProvider>

            <Modal />
        </div>
    );
}

export default CouponManagement;
